export default __webpack_public_path__ + "static/media/master-bg.59fa1d3c.jpg";